import { useCallback, useEffect, useState } from 'react';
import { getPremiacaoTabelaVeiculos } from '@spark/services/premiacao';
import { notification } from '@spark/ui-components/utils/notification';
import { toApiDate } from '@spark/utils/formatters';

const normalizeFilters = (filtros) => (
  Object.fromEntries(
    Object.entries(filtros)
      .filter(([key, value]) => value !== undefined && value !== null && value !== '' && !(key === 'Ativo' && value === false))
      .map(([key, value]) => [key, value instanceof Date ? toApiDate(value) : value])
  )
);

export const usePremiacaoTabelaVeiculoSelection = (show) => {
  const [registros, setRegistros] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filtros, setFiltros] = useState({});
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [quantidadePorPagina, setQuantidadePorPagina] = useState(10);
  const [totalRegistros, setTotalRegistros] = useState(0);

  const carregarRegistros = useCallback(async () => {
    try {
      setLoading(true);
      const params = {
        PaginaAtual: paginaAtual,
        QuantidadePorPagina: quantidadePorPagina,
        ...normalizeFilters(filtros)
      };

      const response = await getPremiacaoTabelaVeiculos(params);
      const data = response?.data || response || {};
      const lista = Array.isArray(data.registros) ? data.registros : [];

      setRegistros(lista);
      setTotalRegistros(data.totalRegistros || lista.length);
    } catch (error) {
      console.error('Erro ao carregar frotas x tabela:', error);
      notification.error(
        error?.message || 'Nao foi possivel carregar as associacoes frota/tabela',
        'Erro ao carregar associacoes'
      );
      setRegistros([]);
      setTotalRegistros(0);
    } finally {
      setLoading(false);
    }
  }, [filtros, paginaAtual, quantidadePorPagina]);

  useEffect(() => {
    if (show) {
      carregarRegistros();
    }
  }, [show, carregarRegistros]);

  const handleFiltrosChange = useCallback((novosFiltros) => {
    setFiltros(novosFiltros);
    setPaginaAtual(1);
  }, []);

  const handlePaginationChange = useCallback((paginationState) => {
    if (paginationState.pageSize !== quantidadePorPagina) {
      setQuantidadePorPagina(paginationState.pageSize);
      setPaginaAtual(1);
    } else if (paginationState.pageIndex !== undefined) {
      setPaginaAtual(paginationState.pageIndex + 1);
    }
  }, [quantidadePorPagina]);

  const resetFiltros = useCallback(() => {
    setFiltros({});
    setPaginaAtual(1);
    setQuantidadePorPagina(10);
  }, []);

  const reload = useCallback(() => {
    carregarRegistros();
  }, [carregarRegistros]);

  return {
    registros,
    loading,
    filtros,
    paginaAtual,
    quantidadePorPagina,
    totalRegistros,
    handleFiltrosChange,
    handlePaginationChange,
    resetFiltros,
    reload
  };
};
